import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../store';
import { LoaderComponent } from 'n2p-ui-library';
import { ErrorPanel } from '../error-panel/error-panel';

export const QuotePreview = observer(() => {
  const { quoteStore, signUpStore } = useStore();
  const { errorCode } = signUpStore;
  const { quoteInfo } = quoteStore;

  useEffect(() => {
    if (quoteInfo?.html) window.location.replace(quoteInfo.html);
  }, [quoteInfo?.html]);

  return errorCode ? <ErrorPanel code={errorCode} /> : <LoaderComponent />;
});
